import { createFileRoute, redirect } from '@tanstack/react-router';

import { getAuthSession, isSessionExpiringSoon, Login } from '@/features/auth';

export const Route = createFileRoute('/auth/_authLayout/login')({
  beforeLoad: async () => {
    const session = await getAuthSession();
    if (session && !isSessionExpiringSoon(session.expires_at)) {
      redirect({ to: '/', replace: true, throw: true });
    }
  },
  component: () => <Login />,
});
